export class CodigoTributacaoRequest {
    pesquisa?: string;
    paginaAtual: number = 1;
    tamanhoPagina: number = 20;
}
